import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login, getToken } from '../../lib/adminApi';
import { Lock } from 'lucide-react';

const AdminLogin = () => {
  const nav = useNavigate();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  React.useEffect(() => { if (getToken()) nav('/admin', { replace: true }); }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(password);
      nav('/admin', { replace: true });
    } catch (err) {
      setError(err?.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-md bg-white border border-[#e0d6c5] p-8 md:p-10 shadow-sm">
        <div className="flex items-center gap-3 mb-6">
          <span className="w-10 h-10 rounded-full bg-[#1a1614] text-[#d4b483] flex items-center justify-center">
            <Lock size={16} />
          </span>
          <div>
            <p className="text-[10px] tracking-[0.32em] uppercase text-[#a67c3d]">RCD Admin</p>
            <h1 className="font-serif text-2xl text-[#1a1614]">Sign in</h1>
          </div>
        </div>

        <label className="block text-xs tracking-[0.2em] uppercase text-[#6b5847] mb-2">Password</label>
        <input
          type="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
          data-testid="admin-login-password"
          className="w-full px-0 py-3 bg-transparent border-b border-[#c9bfae] focus:border-[#1a1614] outline-none text-[#1a1614]"
        />

        {error && (
          <p className="mt-4 text-sm text-red-600" data-testid="admin-login-error">{error}</p>
        )}

        <button
          type="submit"
          disabled={loading}
          data-testid="admin-login-submit"
          className="mt-8 w-full inline-flex justify-center items-center px-6 py-3 bg-[#1a1614] text-[#faf6f0] hover:bg-[#a67c3d] transition-colors disabled:opacity-50"
        >
          {loading ? 'Signing in\u2026' : 'Sign in'}
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;
